import { WorkOrder } from "@/services/backend/vbs/work-orders/types/work-order";
import { useState } from "react";
import {
  UpdateTeamLeaderRequest,
  useVbsWorkOrderUpdateTeamLeaderMutation,
} from "@/services/backend/vbs/work-orders/api/work-order-api";
import { useDebouncedMutation } from "@/shared/lib/debounce/debounce";
import {
  errorsFor,
  useErrDocumentNotReady,
} from "@/shared/bsm/core/document/components/ui/err-document-not-ready";
import { fieldErrors } from "@/shared/lib/errors/validation-error";
import { TextInput } from "@/shared/components/form/text-input";
import t from "@/lang/lang";

export function WorkOrderTeamLeaderInput({
  workOrder,
  disabled,
}: {
  workOrder: WorkOrder;
  disabled?: boolean;
}) {
  const [request, setRequest] = useState<UpdateTeamLeaderRequest>({
    id: workOrder.id,
    teamLeaderId: workOrder.teamLeaderId,
  });
  const mutation = useVbsWorkOrderUpdateTeamLeaderMutation();

  const { error } = useDebouncedMutation(request, setRequest, mutation, {
    id: workOrder.id,
    teamLeaderId: workOrder.teamLeaderId,
  });

  const { notReadyError, resetNotReadyErrorField } = useErrDocumentNotReady();

  const errors = [
    ...(errorsFor(notReadyError, "teamLeaderId") ?? []),
    ...(fieldErrors(error, "teamLeaderId") ?? []),
  ];

  return (
    <TextInput
      label={t("Teamleiter")}
      field="teamLeaderId"
      text={request.teamLeaderId}
      onTextChange={(teamLeaderId) => {
        setRequest({ ...request, teamLeaderId });
        resetNotReadyErrorField("teamLeaderId");
      }}
      errors={errors}
      disabled={disabled}
    />
  );
}
